<template>
  <div style="display: none">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'inlinescript',
  mounted() {
    this.injectScript();
  },
  methods: {
    injectScript() {
      try {
          new Function(this.$el.innerText || this.$el.textContent)() // eslint-disable-line
      } catch (error) {
        console.warn(error);
      }
    },
  },
};
</script>
